import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "popup",
    initialState: null,
    reducers: {
        setPopup: (state, action) => action.payload,
    },
});
